import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
const useSuperAdminStoreBase = create()(persist((set)=>({
        selectedCustomerId: undefined,
        actions: {
            setSelectedCustomer: (customerId)=>set({
                    selectedCustomerId: customerId
                }),
            clearSelectedCustomer: ()=>set({
                    selectedCustomerId: undefined
                })
        }
    }), {
    name: "superadmin-context-storage",
    partialize: (state)=>({
            selectedCustomerId: state.selectedCustomerId
        }),
    storage: createJSONStorage(()=>sessionStorage)
}));
export default function useSuperAdminStore() {
    const selectedCustomerId = useSuperAdminStoreBase((state)=>state.selectedCustomerId);
    const actions = useSuperAdminStoreBase((state)=>state.actions);
    return {
        selectedCustomerId,
        /**
     * Resolves the 3-state selectedCustomerId into a concrete value:
     * - null (all orgs) → ALL_ORGS_ID
     * - undefined (no selection) → fallback
     * - string → that string
     */ getActiveCustomerId: (fallback, allOrgsId)=>selectedCustomerId === null ? allOrgsId : selectedCustomerId === undefined ? fallback ?? "" : selectedCustomerId,
        ...actions
    };
}
export const superAdminStore = useSuperAdminStoreBase;
